export default {
  message: {
    switchLanguage: 'Switch Language',
    common: {
      today: "Today",
      // 基础操作
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      batchDelete: "Batch Delete",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      search: "Search",
      reset: "Reset",
      remove: "Remove",
      view: "View",
      logs: "Log",
      selectAll: "Select All",
      operation: "Operation",
      // 状态
      status: "Status",
      statusMap: {
        "PUBLISH": "Selling",
        "UN_PUBLISH": "Removed",
        "SOLD": "Sold"
      },
      // 查询状态
      queryStatus: "Query Status",
      queryStatusMap: {
        "1": "To be completed",
        "2": "Completed",
        "-1": "Reject"
      },
      // 分类
      category: "Category",
      categoryMap: {
        GOOGLE_PLAY: "Google Play",
        IOS: "iOS",
        ADSENSE: "Adsense",
        ADMOB: "AdMob",
        HUAWEI: "Huawei",
        APPLOVIN: "Applovin",
        MINTEGRAL: "Mintegral",
        META: "Meta",
        IRON_SOURCE: "Iron source",
        UNITY: "Unity",
        CHARTBOOST: "Chartboost",
        INMOBI: "InMobi",
        DIGITAL_TURBINE: "Digital Turbine",
      },
      // 时间
      createTime: "Create time",
      publishTime: "Publish Time",
      // 验证
      validEmail: "Valid Email",
      validPhone: "Valid Phone",
      // 文件
      image: "Image",
      upload: "Click to upload",
      download: "Download",
      // 其他
      keywords: "Keywords",
      name: "Name",
      phone: "Phone",
      developerEmail: "Developer Email",
      content: "Content",
      tips: "Tips",
      success: "Success",
      error: "Error",
      confirmDelete: "Are you sure you want to delete?",
      copySuccess: "Copy success",
      createBy: "Create By",
      viewCount: "View Count",
      // 验证消息
      valid: {
        selectData: "Please select data",
      }
    },
    api: {
      "logout": "Logout",
      "logoutTitle": "You have logged out<br/>Please log in again",
      "reLogin": "Re-login",
      "0000": "System abnormality",
      "0001": "Login expired, please log in again",
      "0010": "Parameter error",
      "0101": "Verification code error",
      "0102": "Username or password error",
      "0103": "Account unavailable",
      "0104": "Data does not exist",
      "0105": "Administrator account cannot be deleted",
      "0106": "Role already exists",
      "0107": "Administrator role cannot be deleted",
      "0108": "Account already exists",
      "0109": "Username already exists",
      "0110": "Unable to find user",
      "0111": "Original password is incorrect",
      "0112": "Mobile number already exists",
      "0113": "Mobile number does not exist",
      "0114": "Mobile number is empty",
      "0115": "Unable to find purchasing information",
      "0116": "Valid email domain incorrect",
      "0117": "Deal price is required when marking as sold",
      "0118": "No ledger permission",
    },
    login: {
      welcome: 'Hi, welcome to 51gp',
      title: "Login account",
      username: "Username",
      password: "Password",
      validCode: "Verification code",
      btn: "Login",
      copyright: "Copyright: 51gp",
      rule: {
        passwordLess: "Password cannot be less than 6 digits",
        usernameRequired: "Please enter the user",
        validRequired: "Please enter the verification code",
      }
    },
    source: {
      module: "Supplier",
      parseStatusLabel: "Parse Status",
      parseStatus: {
        "0": "Not in the warehouse",
        "1": "In the warehouse",
        "2": "Repeat",
        "3": "Incomplete information",
        "4": "Parse Fail",
      },
      email: "Email",
      valid: {
        selectData: "Please select data",
        content: "Please enter account information",
        name: "Please enter name",
        phone: "Please enter phone",
        developerEmail: "Please enter developer email",
        category: "Please select an account category (required)",
        developerEmailFormat: "Developer email format is invalid",
        images: "Please add image"
      },
      parseErrorMsgs: {
        "ERROR_CATEGORY_REQUIRED": "The supplier must select an account category",
        "ERROR_COUNTRY_EMPTY": "Country is empty",
        "ERROR_PKG_URL_EMPTY": "GP link is empty",
        "ERROR_PURCHASE_PRICE_EMPTY": "Purchase price is empty",
        "ERROR_SOLD": "Sold",
        "ERROR_REPEAT": "Repeated",
        "ERROR_ALIYUN_CALL_ERROR": "Call Aliyun Error"
      },
      accountRepeated: "Account Repeated",
      summary: {
        waitComplete: "Wait Complete",
        completed: "Completed",
        reject: "Reject",
        soldMissingBuy: "Missing Buy Price",
        monthTransactionCount: "Month Transactions",
      },
      missingBuyTag: "Missing Buy Price",
      reject: "Reject",
      editTip: "Incomplete fields below. Please fill them in and save.",
      supplementTitle: "Complete account fields (fill as needed, auto re-parse after save)",
      supplementRequired: "Account Info",
      supplementRequiredHint: "Country / Price / GP link",
      accountFields: "Account Info",
      supplementAppCounts: "App counts",
      supplementTags: "Account tags",
      supplementSupplier: "Supplier info",
      contentHint: "Original pasted text, expand to edit",
      pkgUrlsPlaceholder: "Paste Google Play app link(s), one per line"
    },
    accountInfo: {
      module: "Developer account",
      moreSearch: "More search conditions",
      registerTime: "Time",
      country: "Country",
      appCount: "APP",
      unPubAppCount: "Un Published",
      pauseCount: "Pause",
      rejectCount: "Reject",
      selectAll: "Select All",
      deleteCount: "Delete",
      draftCount: "Draft",
      transferCount: "Transfer",
      sourceCode: "Source Code",
      secretKey: "Secret Key",
      language: "Language",
      admob: "Admob",
      org: "Enterprise",
      highDownload: "High Download",
      paymentInfo: "Payment",
      access: "Access",
      verify: "Verified",
      purchasePrice: "Purchase Price",
      sellingPrice: "Selling Price",
      dealPrice: "Deal Price",
      buyPrice: "Buy Price",
      pkgUrls: "Link",
      index: "NO",
      url: "Link",
      cancelView: "Cancel View",
      sourceId: "Purchase ID",
      source: "Source",
      sourceName: "Source Name",
      sourcePhone: "Source phone",
      developerEmail: "Developer Email",
      recoveryEmail: "Recovery Email",
      recoveryPhone: "Recovery Phone",
      repeated: "Repeat",
      year: "Year",
      repeatInfo: "Repeat",
      repeatType: "Type",
      repeatTypes: {
        "1": "Today",
        "2": "History"
      },
      affiliateUserName: "Trader",
      buyerUserName: "Buyer",
      soldTime: "Sold Time",
      more: "More",
      valid: {
        selectData: "Select data",
        sourceId: "Please enter purchase ID",
        registerTime: "Please select time",
        country: "Please select country",
        purchasePrice: "Please enter Purchase price",
        sellingPrice: "Please enter Selling price",
        dealPrice: "Please enter Deal price",
        soldTime: "Please select sold time",
        buyPrice: "Please enter Buy price",
        developerEmail: "Please enter developer email",
        url: "Please fill in URL",
        pkgUrls: "Please add link",
      },
      type: "Type",
      types: {
        game: "Game",
        tool: "Tool",
        info: "Information"
      },
      expandSearch: "Expand",
      collapseSearch: "Collapse",
      apple: "iOS",
      createByName: "Create By",
      accountQuality: "Account Quality",
      accountQualityMap: {
        "high": "High Quality",
        "normal": "Normal",
        "risk": "Risk"
      },
      sectionSource: "Supplier",
      sectionBasic: "Basic Info",
      sectionAttrs: "Attributes",
      sectionPrice: "Price & Deal",
      sectionContact: "Contact",
      sectionMedia: "Apps & Media",
      queryStatusAction: "Add Query",
      queryStatusCancelAction: "Cancel Query",
      summary: {
        waitComplete: "Wait Complete",
        completed: "Completed",
        reject: "Reject",
        todayNewAdd: "Today Add",
        todayRepeat: "Today Repeat",
        myQuery: "My Query",
        missingDeal: "Missing Deal Price",
        missingBuy: "Missing Buy Price",
        monthTransactionCount: "Month Transactions",
      }
    },
    emailTemplate: {
      module: "Email Template",
    },
    ledger: {
      module: "Ledger",
      dateRange: "Sold Date",
      count: "Deals",
      dealAmount: "Deal Amount",
      buyAmount: "Buy Amount",
      profit: "Profit",
      missingBuyCount: "Missing Buy",
      missingDealCount: "Missing Deal",
      chartTitle: "Daily Deal Curve",
      listTitle: "Deal History",
      dealPrice: "Deal Amount",
      buyPrice: "Buy Price",
      missingBuy: "Missing Buy Price",
      missingDeal: "Missing Deal Price",
      add: "+ Add",
      edit: "Edit Deal",
      buyer: "Buyer",
      staff: "Trader",
      buyerPlaceholder: "Type or select buyer",
      staffPlaceholder: "Type or select trader",
      validEmail: "Recovery Email",
      validPhone: "Recovery Phone",
      accountInfo: "Account Info",
      viewInfo: "View Info",
      extraCost: "Extra Cost",
      extraCostPlaceholder: "e.g. phone, VPS",
      paymentCurrency: "Payment Currency",
      none: "None",
      sectionDeal: "Deal Info",
      sectionAccount: "Account Info",
      sectionContact: "Contact & Staff",
      paymentCurrencyOptions: {
        private: "CNY-Private",
        qrcode: "CNY-QR"
      },
      valid: {
        dealPrice: "Please enter deal amount",
        soldTime: "Please select sold date",
        category: "Please select category"
      }
    },
    sys: {
      module: "System",
      admin: {
        module: "System account",
        search: "Search",
        operation: "Operation",
        roleList: "Role list",
        roleName: "Role name",
        dataPermission: "Data permission",
        permissionEditor: {
          priceOverview: "Roles and pricing",
          overviewHint: "Amounts are in RMB. Select a role to configure permissions and pricing. AppLovin shows the extra purchase markup.",
          readOnly: "Read only",
          purchaseAdjustment: "Base purchase adjustment",
          sellingAdjustment: "Base selling adjustment",
          purchaseColumn: "Purchase",
          sellingColumn: "Sale",
          rawRoleHint: "Admins and suppliers are exempt from the extra AppLovin markup. Existing base adjustments still apply.",
          notApplied: "Exempt",
          newRole: "New role",
          priceRules: "Pricing rules",
          applovinExtra: "Extra AppLovin purchase markup",
          priceRuleHint: "Base adjustments are recorded when an account is parsed. The extra AppLovin markup uses the current role configuration without changing the supplier price.",
          preview: "Purchase price example",
          supplierPrice: "Example purchase base",
          sellingPreview: "Selling price example",
          sellingBasePrice: "Example selling base",
          sellingResult: "Adjusted selling price (all categories)",
          sellingPreviewHint: "Selling base price + base selling adjustment. Negative adjustments reduce the price. The extra AppLovin markup only affects purchase prices.",
          sellingHidden: "This role cannot view actual account selling prices. The example result above remains visible.",
          otherCategory: "Other categories",
          previewHint: "The two example base prices are calculated independently for preview only. They are not saved and do not affect actual account prices. Each example uses its respective adjustment above. Existing accounts retain the base adjustments recorded during parsing. Zero prices stay zero.",
          purchaseHidden: "This role cannot view actual account purchase prices. The example results above remain visible.",
          permissionSettings: "Permissions",
          permissionHint: "Disabling view also clears edit and hide settings for that field. Hide list value affects list values only.",
          searchFields: "Search field names",
          categoryLocked: "A category must be selected when uploading. Later changes require category edit permission in the relevant module, including for the creator.",
          visibleFields: "fields visible",
          clearFields: "Clear field access",
          selectFields: "View all fields",
          fieldName: "Field",
          view: "View",
          hideListValue: "Hide list value",
          locked: "Locked",
          noMatchingFields: "No matching fields",
          clearOperations: "Clear operations",
          selectOperations: "Allow all operations",
          readOnlyHint: "The system administrator role is read only.",
          saveHint: "Changes take effect after saving.",
          saveRole: "Save role",
        },
        applovinFloatLabel: "AppLovin extra purchase markup (¥)",
        floatLabel: "Float",
        permHint: "Check a module on the left to expand its columns and operations",
        edit: "Edit",
        cancelEdit: "Cancel edit",
        delete: "Delete",
        add: "Add",
        username: "Username",
        password: "Password",
        confirmPassword: "Confirm password",
        name: "Name",
        phone: "Phone number",
        email: "Email",
        role: "Role",
        cancel: "Cancel",
        confirm: "Confirm",
        addOrEdit: "Add or delete user",
        createTime: "Create time",
        tips: "Tips",
        success: "Success",
        view: "View",
        cancelView: "Cancel view",
        confirmDelete: "Are you sure you want to delete?",
        checkAll: "Select all",
        columns: "Fields",
        editable: "Editable",
        viewable: "Viewable",
        noData: "No Data",
        updatePassword: "Change password",
        logout: "Log out",
        originPassword: "Original password",
        newPassword: "New password",
        accountInfoStatusMap: {
          "PUBLISH": "Selling",
          "UN_PUBLISH": "Removed",
          "SOLD": "Sold"
        },
        status: "Status",
        parentName: "Create By",
        workStatus: "Work Status",
        affiliate: "Affiliate",
        userName: "Username",
        month: "Month",
        day: "Day",
        count: "Count",
        onlineTime: "Online Time",
        totalLoginCount: "Total Login Count",
        todayLoginCount: "Today Login Count",
        loginLog: "Login Log",
        loginIp: "Login IP",
        loginCountry: "Login Country",
        loginCity: "Login City",
        summary: "Summary",
        more: "More",
        childAdminSummary: "Child Admin Summary",
        supplierUpload: "Supplier Uploads",
        uploadCount: "Uploads",
        supplierParent: "Parent",
        addUserCount: "Number of customers",
        addAccountCount: "Number of accounts",
        addSubAccountCount: "Number of accounts (sub-accounts)",
        valid: {
          emailIncorrect: "Please enter valid email address",
          emailRequire: "Please enter email address",
          phone: "Please enter phone number",
          username: "Please enter your username",
          password: "Please enter your password",
          roleName: "Please enter your role name",
          permission: "Please select permissions",
          usernameExists: "Username already exists",
          role: "Please enter your role",
          passwordRepeat: "Confirm passwords do not match"
        },
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/admin/i18n/en.js